import { Component, OnInit } from '@angular/core';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';

@Component({
  selector: 'app-documents-sends',
  templateUrl: './documents-sends.component.html',
  styleUrls: ['./documents-sends.component.scss'],
})
export class DocumentsSendsComponent {
  constructor(
    public copyService: CopyService,
    private navigationService: NavigationService,
  ) {}

  back() {
    this.navigationService.nextStep('201');
  }
}
